import React, { FC } from 'react';
import { Check, CheckCheck, X, AlertTriangle, HelpCircle } from 'lucide-react';
import { StatusType } from '../NewVerificationTab.styles';

interface StatusIconProps {
  status: StatusType;
  variant?: 'default' | 'automated';
}

export const StatusIcon: FC<StatusIconProps> = ({ status, variant = 'default' }) => {
  if (variant === 'automated') {
    return <AutomatedMatchingIcon status={status} />;
  }
  return <DefaultStatusIcon status={status} />;
};

const DefaultStatusIcon: FC<{ status: StatusType }> = ({ status }) => {
  switch (status) {
    case 'Match':
      return <Check className='w-4 h-4 text-[#1c2024]' />;
    case 'Mismatch':
      return <X className='w-4 h-4 text-[#1c2024]' />;
    case 'PartialMatch':
      return <AlertTriangle className='w-4 h-4 text-[#1c2024]' />;
    case 'NotRelevant':
      return <HelpCircle className='w-4 h-4 text-[#1c2024]' />;
    default:
      return null;
  }
};

const AutomatedMatchingIcon: FC<{ status: StatusType }> = ({ status }) => {
  switch (status) {
    case 'Match':
      return <CheckCheck className='w-4 h-4 text-green-600' />;
    case 'PartialMatch':
      return <Check className='w-4 h-4 text-green-600' />;
    case 'Mismatch':
      return <X className='w-4 h-4 text-red-600' />;
    case 'NotRelevant':
      return <span className='text-[#1c2024] text-sm font-bold leading-4'>?</span>;
    case 'Unknown':
      return <span className='text-[#1c2024] text-sm font-bold leading-4'>?</span>;
    case null:
      return <span className='text-[#1c2024] text-sm font-bold leading-4'>?</span>;
    default:
      return <span className='text-[#1c2024] text-sm font-bold leading-4'>?</span>;
  }
};
